module.exports = __webpack_public_path__ + "public/img/banner.c32ad524.png";